module.exports = __webpack_public_path__ + "static/media/cake.2098b42e.jpg";